/* Avanti product page upgrades: Subscribe & Save picker and "Notify me" for Coming soon variants. */
(function () {
  'use strict';

  var KLAVIYO_REVISION = '2024-10-15';

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function getScope(el) {
    return el.closest('.product-form') || el.closest('[data-section-type="main-product"]') || document;
  }

  function getIdInput(scope) {
    return scope.querySelector('form.product-purchase-form [name="id"]');
  }

  function getVariantId(scope) {
    var input = getIdInput(scope);
    return input ? String(input.value || '') : '';
  }

  /* Calls cb(variantId) whenever the selected variant changes. The theme may update the
     variant select without firing a native change event, so a light poll backs up the listeners. */
  function watchVariant(scope, cb) {
    var last = null;
    function check() {
      var id = getVariantId(scope);
      if (id !== last) {
        last = id;
        cb(id);
      }
    }
    var input = getIdInput(scope);
    if (input) {
      input.addEventListener('change', function () { setTimeout(check, 0); });
      if (window.jQuery) {
        try { window.jQuery(input).on('change', function () { setTimeout(check, 0); }); } catch (e) {}
      }
    }
    scope.addEventListener('change', function () { setTimeout(check, 0); });
    setInterval(check, 400);
    check();
    return check;
  }

  /* ---------------- Subscribe & Save ---------------- */

  function renderPriceFromTemplate(area, variantId) {
    var tpl = area.querySelector('script[type="text/template"][data-variant-id="' + variantId + '"]');
    if (!tpl) return;
    toArray(area.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'SCRIPT') return;
      area.removeChild(n);
    });
    var holder = document.createElement('div');
    holder.innerHTML = tpl.innerHTML;
    toArray(holder.childNodes).forEach(function (n) { area.appendChild(n); });
  }

  function initSub(root) {
    if (root.__avInit) return;
    root.__avInit = true;

    var data;
    try { data = JSON.parse(root.querySelector('[data-av-sub-data]').textContent); } catch (e) { return; }
    var scope = getScope(root);
    var requires = root.getAttribute('data-requires') === 'true';
    var input = root.querySelector('[data-av-plan-input]');
    var select = root.querySelector('[data-av-plan]');
    var freq = root.querySelector('[data-av-freq]');
    var saveEl = root.querySelector('[data-av-save]');
    var oncePrice = root.querySelector('[data-av-once-price]');
    var subPrice = root.querySelector('[data-av-sub-price]');
    var radios = toArray(root.querySelectorAll('input[data-av-mode]'));
    var onceRadio = radios.filter(function (r) { return r.value === 'once'; })[0];
    var subRadio = radios.filter(function (r) { return r.value === 'sub'; })[0];
    var priceArea = scope.querySelector('.price-container .variant-visibility-area');
    var priceOverridden = false;

    function mode() {
      if (requires) return 'sub';
      return subRadio && subRadio.checked ? 'sub' : 'once';
    }

    function setText(el, txt) {
      if (el && el.textContent !== txt) el.textContent = txt;
    }

    function applyPrice(variant, alloc, variantId) {
      if (!priceArea) return;
      if (!alloc) {
        if (priceOverridden) {
          priceOverridden = false;
          renderPriceFromTemplate(priceArea, variantId);
        }
        return;
      }
      var wrap = priceArea.querySelector('.price-area .price');
      if (!wrap) return;
      var current = wrap.querySelector('.current-price');
      if (!current) return;
      setText(current, alloc.price);
      var was = wrap.querySelector('.was-price');
      var compare = alloc.compare || variant.compare || variant.price;
      if (compare && compare !== alloc.price) {
        if (!was) {
          was = document.createElement('span');
          was.className = 'was-price theme-money';
          current.parentNode.insertBefore(was, current.nextSibling);
        }
        setText(was, compare);
      } else if (was) {
        was.parentNode.removeChild(was);
      }
      priceOverridden = true;
    }

    function apply() {
      var variantId = getVariantId(scope);
      var variant = data.variants[variantId];
      var planId = select ? select.value : (input ? input.value : '');
      var alloc = variant && variant.plans ? variant.plans[planId] : null;

      if (subRadio) subRadio.disabled = !alloc && !requires;
      if (!alloc && !requires && subRadio && subRadio.checked && onceRadio) {
        onceRadio.checked = true;
      }

      // Coming soon variant: nothing to buy, so the purchase options step aside.
      root.hidden = !!(variant && variant.available === false);

      var m = mode();
      var isSub = m === 'sub';
      root.classList.toggle('is-sub', isSub);
      radios.forEach(function (r) {
        var label = r.closest('.av-sub__opt');
        if (label) label.classList.toggle('is-checked', r.checked || (requires && r === subRadio));
      });
      if (freq) freq.hidden = !isSub;

      if (input) {
        input.value = planId;
        input.disabled = !isSub;
      }

      if (variant) setText(oncePrice, variant.price);
      setText(subPrice, alloc ? alloc.price : '');

      var opt = select && select.options[select.selectedIndex];
      var save = opt ? (opt.getAttribute('data-save') || '') : '';
      if (saveEl) {
        setText(saveEl, save);
        saveEl.hidden = !save;
      }

      applyPrice(variant || {}, isSub ? alloc : null, variantId);
    }

    radios.forEach(function (r) { r.addEventListener('change', apply); });
    if (select) select.addEventListener('change', apply);

    if (priceArea && 'MutationObserver' in window) {
      new MutationObserver(function () {
        // The theme re-rendered the price for a new variant: re-apply the subscription price.
        priceOverridden = false;
        if (mode() === 'sub') apply();
      }).observe(priceArea, { childList: true });
    }

    watchVariant(scope, apply);
    apply();
    root.__avApply = apply;
  }

  /* ---------------- Notify me (Klaviyo back in stock) ---------------- */

  function findCompanyId(root) {
    var id = root.getAttribute('data-company');
    if (id) return id;
    var s = document.querySelector('script[src*="klaviyo.js?company_id="], script[src*="klaviyo.js?company_id%3D"]');
    if (s) {
      var m = /company_id=([A-Za-z0-9]+)/.exec(s.getAttribute('src'));
      if (m) return m[1];
    }
    return '';
  }

  function productJson(scope, root) {
    var detail = root.closest('.product-detail') || scope;
    var el = detail.querySelector('script[id^="ProductJson-"]') || document.querySelector('script[id^="ProductJson-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function klaviyoPost(path, companyId, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    });
  }

  function subscribeBackInStock(companyId, email, variantId, lang) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };
    return klaviyoPost('back-in-stock-subscriptions', companyId, payload).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      if (lang === 'fr') {
        // The French Back in Stock flow filters on the profile's Language property.
        klaviyoPost('profiles', companyId, {
          data: { type: 'profile', attributes: { email: email, properties: { Language: 'French' } } }
        }).catch(function () {});
      }
      return true;
    });
  }

  function initNotify(root) {
    if (root.__avInit) return;
    root.__avInit = true;

    var scope = getScope(root);
    var toggle = root.querySelector('[data-av-notify-toggle]');
    var form = root.querySelector('[data-av-notify-form]');
    var emailInput = form ? form.querySelector('input[type="email"]') : null;
    var submit = form ? form.querySelector('button[type="submit"]') : null;
    var msg = root.querySelector('[data-av-notify-msg]');
    var lang = root.getAttribute('data-lang') || 'en';
    var product = productJson(scope, root);
    var availability = {};
    if (product && product.variants) {
      product.variants.forEach(function (v) { availability[String(v.id)] = !!v.available; });
    }
    var productAvailable = root.getAttribute('data-product-available') === 'true';
    var currentVariant = '';
    var done = {};

    function setMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('is-error', !!isError);
    }

    function close() {
      if (!form) return;
      form.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function update(variantId) {
      currentVariant = variantId;
      var unavailable;
      if (variantId && Object.prototype.hasOwnProperty.call(availability, variantId)) {
        unavailable = !availability[variantId];
      } else {
        unavailable = !productAvailable;
      }
      root.hidden = !unavailable;
      if (!unavailable) close();
      if (done[variantId]) {
        setMsg(root.getAttribute('data-msg-ok'), false);
        if (form) form.classList.add('is-done');
      } else {
        setMsg('', false);
        if (form) form.classList.remove('is-done');
      }
    }

    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var open = form.hidden;
        form.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && emailInput && !form.classList.contains('is-done')) {
          try { emailInput.focus({ preventScroll: true }); } catch (e) { emailInput.focus(); }
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailInput.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          setMsg(root.getAttribute('data-msg-invalid'), true);
          emailInput.focus();
          return;
        }
        var companyId = findCompanyId(root);
        var variantId = currentVariant || getVariantId(scope) || (product && product.variants && product.variants[0] ? String(product.variants[0].id) : '');
        if (!companyId || !variantId) {
          setMsg(root.getAttribute('data-msg-error'), true);
          return;
        }
        if (submit) submit.disabled = true;
        setMsg('', false);
        subscribeBackInStock(companyId, email, variantId, lang).then(function () {
          done[variantId] = true;
          form.classList.add('is-done');
          setMsg(root.getAttribute('data-msg-ok'), false);
        }).catch(function () {
          setMsg(root.getAttribute('data-msg-error'), true);
        }).then(function () {
          if (submit) submit.disabled = false;
        });
      });
    }

    watchVariant(scope, update);
  }

  /* ---------------- Boot ---------------- */

  function initAll(ctx) {
    toArray((ctx || document).querySelectorAll('[data-av-sub]')).forEach(initSub);
    toArray((ctx || document).querySelectorAll('[data-av-notify]')).forEach(initNotify);
  }

  function boot() {
    initAll(document);
    if ('MutationObserver' in window) {
      // Quick buy and theme editor reloads insert new product forms later.
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.matches('[data-av-sub],[data-av-notify]') || n.querySelector('[data-av-sub],[data-av-notify]'))) {
              initAll(n.nodeType === 1 && n.matches('[data-av-sub],[data-av-notify]') ? n.parentNode : n);
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.AvantiPDP = { init: initAll, _subscribeBackInStock: subscribeBackInStock };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
